import { MarketsLayout } from '~/domains/market/components/MarketsLayout/MarketsLayout';
import { useHasSelection } from '~/domains/market/state/marketSelection.store';
import { DesktopSelectionPanel } from '~/domains/market/components/DesktopSelectionPanel/DesktopSelectionPanel';
import MarketBrowsePage from '~/domains/market/pages/browse';
import { PredictionMarketsRouteGate } from '~/domains/market/components/PredictionMarketsRouteGate/PredictionMarketsRouteGate';

function MarketsPageRoute() {
  const hasSelection = useHasSelection();

  return (
    <PredictionMarketsRouteGate>
      <MarketsLayout.Full
        rightSidebar={hasSelection ? <DesktopSelectionPanel /> : undefined}
        mobileNavVariant="browse"
        showMobileKycBanner
      >
        <MarketBrowsePage />
      </MarketsLayout.Full>
    </PredictionMarketsRouteGate>
  );
}

export default MarketsPageRoute;
MarketsPageRoute.isPublic = true;
MarketsPageRoute.hasAppBanners = false;
MarketsPageRoute.hideFooter = true;
